import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity, useLang } from '@shapeable/ui';
import { useSite } from '../../hooks/use-site';
import { ValueBubble } from '../elements/value-bubble';
import { BubbleStyles } from '../../theme';
import { MetricLayout } from '../entities/metric-layout';

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ValueStyles = breakpoints({
  base: css`
    ${BubbleStyles};
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
    Value: styled(ValueBubble)`${ValueStyles}`,
};

export const BlockLayoutTotalJobsCreated: BlockLayoutComponent = (props) => {
  const { className, children } = props;
  const entity = useEntity(props.entity);
  const t = useLang();
  const { metrics } = useSite();
  const { totalJobsCreated } = metrics;

  return (
    <My.Container showContent entity={entity} className={className}>
      <My.Value comingSoon value={totalJobsCreated} name={t('Jobs Created (N)')} /> 
    </My.Container>
  )
};